<template>
  <modal
    :name="modalName"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="loadDependencias"
    @opened="capturarSnapshotInicial"
  >
    <CloseModal :close="closeModal" />
    <Loading :isActive="loading" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Informações Gerais">
            <StepInformacoesGerais :form="item" />
          </CTab>
          <CTab title="Regras">
            <StepRegras :form="item" ref="stepRegras" />
          </CTab>
          <CTab title="Restrições">
            <StepRestricoes :item="item" :tiposRestricao="tiposRestricao" />
          </CTab>
          <CTab title="Resumo">
            <StepResumo :item="item" :tiposRestricao="tiposRestricao" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="closeModal">
        Cancelar
      </CButton>
      <CButton color="primary" @click="handleSubmit" :disabled="loading">
        Salvar Alterações
      </CButton>
    </div>
  </modal>
</template>

<script>
import { get, post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal.vue";
import Loading from "@/components/Loading.vue";
import StepInformacoesGerais from "./sections/StepInformacoesGerais.vue";
import StepRegras from "./sections/StepRegras.vue";
import StepRestricoes from "./sections/StepRestricoes.vue";
import StepResumo from "./sections/StepResumo.vue";

export default {
  name: "ModalSinaleiraLucratividade",
  props: {
    item: { type: Object, required: true },
    close: { type: Function, required: true },
  },
  components: {
    CloseModal,
    Loading,
    StepInformacoesGerais,
    StepRegras,
    StepRestricoes,
    StepResumo,
  },
  data() {
    return {
      modalName: "ModalSinaleiraLucratividade",
      loading: false,
      tiposRestricao: [],
      // Snapshot dos campos relevantes para cancelamento, capturado quando o
      // modal abre em modo edicao. Usado para decidir se exibe o aviso de
      // cancelamento das negociacoes ao salvar.
      snapshotOriginal: null,
    };
  },
  methods: {
    loadDependencias() {
      this.loading = false;
      this.snapshotOriginal = null;
      get("/admin/sinaleira-lucratividade/tipos-restricao")
        .then((json) => {
          this.tiposRestricao = json;
        })
        .catch(() => {});
    },
    capturarSnapshotInicial() {
      // Captura no `opened` (e nao no `before-open`) porque a prop `item` so
      // esta totalmente propagada apos o modal abrir. Tambem garante que os
      // CTabs e os Steps ja montaram, evitando snapshot antes de qualquer
      // normalizacao de tipos feita por filhos.
      this.snapshotOriginal = this.item && this.item.id
        ? this.snapshotCamposRelevantes(this.item)
        : null;
    },
    snapshotCamposRelevantes(item) {
      const num = (v) => (v === null || v === undefined || v === "" ? null : Number(v));
      const bool = (v) => (v === 1 || v === true || v === "1" || v === "true" ? 1 : 0);
      const str = (v) => (v === null || v === undefined ? "" : String(v));
      const regras = (item.regras || [])
        .slice()
        .sort((a, b) => (num(a.margemMinima) ?? 0) - (num(b.margemMinima) ?? 0))
        .map((r) =>
          [str(r.label), str(r.cor), str(r.indicador), str(r.orientacao), num(r.margemMinima)].join("|")
        )
        .join(";");
      const restricoes = (item.restricoes || [])
        .slice()
        .map((r) => [str(r.tipo), str(r.chave ?? r.tipo_id)].join("|"))
        .sort()
        .join(";");
      return JSON.stringify({
        margemMinimaLiberar: num(item.margemMinimaLiberar),
        margemMinimaAnalisar: num(item.margemMinimaAnalisar),
        prioridade: num(item.prioridade),
        ativo: bool(item.ativo),
        aplicacallcenter: bool(item.aplicacallcenter),
        aplicafv: bool(item.aplicafv),
        regras,
        restricoes,
      });
    },
    houveMudancaRelevante() {
      if (!this.snapshotOriginal) return true;
      return this.snapshotCamposRelevantes(this.item) !== this.snapshotOriginal;
    },
    handleSubmit() {
      const stepRegras = this.$refs.stepRegras;
      if (stepRegras && typeof stepRegras.commitInlineEdit === "function") {
        const result = stepRegras.commitInlineEdit();
        if (!result.ok) {
          this.$swal({
            title: "Edição pendente",
            text:
              "Há uma faixa em edição com campos obrigatórios faltando. Conclua ou cancele a edição antes de salvar.",
            icon: "warning",
          });
          return;
        }
      }
      if (this.item.id) {
        this.confirmUpdate();
      } else {
        this.create();
      }
    },
    confirmUpdate() {
      if (!this.houveMudancaRelevante()) {
        this.update();
        return;
      }
      this.$swal({
        title: "Confirmar atualização da sinaleira?",
        html: `
          <p>Todas as <strong>negociações pendentes ou autorizadas com orçamento em aberto</strong> que utilizam essa sinaleira serão <strong>canceladas</strong>.</p>
        `,
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((res) => {
        if (res.isConfirmed) {
          this.update();
        }
      });
    },
    create() {
      this.loading = true;
      post("/admin/sinaleira-lucratividade", this.item)
        .then(() => {
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao cadastrar",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    update() {
      this.loading = true;
      put(`/admin/sinaleira-lucratividade/${this.item.id}`, this.item)
        .then(() => {
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao atualizar",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    },
  },
};
</script>

<style scoped>
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>

<style>
.modalbox .tab-pane {
  padding: 14px 16px !important;
}

.modalbox .form-group {
  margin-bottom: 10px;
}
</style>
